export default __webpack_public_path__ + "static/media/tubes.67287d86.svg";